import React from "react";

const Detail = () => {
    return <div>Detail Template</div>;
};

export default Detail;
